// @ts-check
import { useGetters } from 'vuex-composition-helpers/dist';
import { useUserRole } from '@/composables/user';
import { usePlans } from '@/composables/plans';
import { ref } from 'vue';
import HTTP from '@/utils/http';
import { captureError } from '@/lib/sentry';

export function useBrandingUpsell() {
  /** @type {import('@/store/modules/branding').Getters} */
  const {
    getBranding: brandingData,
  } = useGetters({
    getBranding: 'branding/getBranding',
  });

  const hasTried = ref(false);
  const metaDataLoaded = ref(false);

  async function fetch() {
    hasTried.value = false;

    try {
      const response = await HTTP({
        url: 'branding/meta',
      });

      hasTried.value = response.data.data.hasTried;
    } catch (error) {
      captureError(error);
    } finally {
      metaDataLoaded.value = true;
    }
  }

  fetch();

  return {
    canUpgrade: useUserRole().isSuperAdmin,
    canAccess: usePlans().hasBrandingAccess,
    hasTried,
    brandingData,
    metaDataLoaded,
  };
}
